export default __webpack_public_path__ + "static/media/Dial_Navy_Yellow.566469a6.png";